import { Component, ViewEncapsulation } from '@angular/core';
import { DispatchesService } from '@app/cp/shared/services/dispatches.service';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { v_DispatchPartBus } from '@app/cp/shared/models/v_DispatchPartBus';
import { BaseGridUIComponent } from '@app/cp/shared/base-components/base-grid-ui.component';

@Component({
    selector: 'job-parts-used',
    templateUrl: './job-parts-used.component.html',
    styleUrls: ['./job-parts-used.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class JobPartsUsedComponent extends BaseGridUIComponent<v_DispatchPartBus, null, DispatchesService>  {

  constructor(globals: GlobalsService, svc_data: DispatchesService) {
    super(globals);
    this.svc_data = svc_data;
  }
}
